import {CheckCircleIcon, XCircleIcon} from '@heroicons/react/outline';

const getVerificationBadge = (isVerified: boolean) => {
  if (isVerified) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-green-100 text-green-700 rounded-lg border border-green-300 dark:bg-green-900/30 dark:text-green-300 dark:border-green-700">
        <CheckCircleIcon className="w-5 h-5" />
        <span className="text-sm font-semibold">Verified</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-red-100 text-red-700 rounded-lg border border-red-300 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700">
      <XCircleIcon className="w-5 h-5" />
      <span className="text-sm font-semibold">Unverified</span>
    </div>
  );
};

export {getVerificationBadge};
